import { CopilotCreateData, CopilotPresetTag, CopilotUpdateData } from 'shared/types/copilot'
import { CreationToolUploadContextProps } from '../../types'

export function createDataFromUploadContext(
    name: string,
    context: CreationToolUploadContextProps,
    optionalTags: CopilotPresetTag[] = []
): CopilotCreateData {
    const { isPublic, rating, sourceUrl, tags: uploadTags, username } = context

    const tags = uploadTags
        .filter((t) => !t.isFeatured)
        .map((t) => t.text)
        .join(',')

    const featured_tags = uploadTags
        .filter((t) => t.isFeatured)
        .map((t) => t.text)
        .join(',')

    return {
        // uncomment this when collections input supports default value
        // collections: channelId,
        collections: '',
        featured_tags,
        is_hidden: !isPublic,
        name,
        optional_tags: optionalTags.map((t) => t.name).join(','),
        rating: rating.toUpperCase(),
        source_url: sourceUrl,
        tags,
        username,
    }
}

export function hasUploadContextChanged(context: CreationToolUploadContextProps, loggedInUsername?: string): boolean {
    const { channelId, isPublic, rating, sourceUrl, tags, username } = context

    if (channelId) {
        return true
    }

    if (!isPublic) {
        return true
    }

    if (rating) {
        return true
    }

    if (sourceUrl) {
        return true
    }

    if (tags.length) {
        return true
    }

    if (username !== loggedInUsername) {
        return true
    }

    return false
}

export function updateDataFromUploadContext(name: string, context: CreationToolUploadContextProps): CopilotUpdateData {
    const data = createDataFromUploadContext(name, context)

    return {
        ...data,
        update_datetime: new Date().toJSON(),
    }
}
